<ion-content *ngIf="appointment?.forms?.length; else empty">
     <ion-list>
          <ion-item-group *ngFor="let workforceForm of appointment.forms; index as index">
               <ion-item lines="full"
                         (click)="onClickToggleSection(index)"
                         mode="md"
                         button>
                    <ion-text>
                         {{ workforceForm.formName }}
                    </ion-text>
                    <div slot="end">
                         <ion-icon slot="end"
                                   class="toggle-arrow"
                                   [name]="
						isVisible(index)
							? 'chevron-up-outline'
							: 'chevron-down-outline'
					"></ion-icon>
                    </div>

               </ion-item>
               <ion-item lines="none"
                         *ngIf="isVisible(index)"
                         color="light"
                         mode="md">
                    <ion-grid>
                         <ion-row *ngFor="let fieldEntry of workforceForm.entries">
                              <ion-col size="4" size-sm>
                                   <ion-label class="ion-text-wrap bold">
                                        {{ fieldEntry.displayValue }}
                                   </ion-label>
                              </ion-col>
                              <ion-col size="8" size-sm>
                                   <ion-text *ngIf="fieldEntry.value.length > 40">{{ fieldEntry.value.substring(0, 40).concat("...") }}</ion-text>
                                   <ion-text *ngIf="fieldEntry.value.length <= 40 && fieldEntry.fieldTypeDescription ==='CheckBox'">{{ fieldEntry.value == 0 ? 'No' : 'Yes'}}</ion-text>
                                   <ion-text *ngIf="fieldEntry.value.length <= 40 && fieldEntry.fieldTypeDescription !=='CheckBox'">{{ fieldEntry.value }}</ion-text>
                              </ion-col>
                         </ion-row>
                         <ion-row>
                              <ion-col size="6" size-sm>
                                   <ion-button color="primary"
                                               expand="block"
                                               (click)="onClickEditWorkforceForm(workforceForm)"
                                               [disabled]="hasSignature(workforceForm)">
                                        Edit
                                   </ion-button>
                              </ion-col>
                              <!--<ion-col size="6" size-sm>
                               <ion-button color="danger"
                                  expand="block"
                                  (click)="onClickDeleteWorkforceForm(workforceForm)">
                                Delete
                               </ion-button>
                              </ion-col>-->
                         </ion-row>
                    </ion-grid>
               </ion-item>
          </ion-item-group>
     </ion-list>
</ion-content>

<ng-template #empty>
     <app-empty-list-item message="No forms exist for appointment"></app-empty-list-item>
</ng-template>

<ion-fab vertical="bottom" horizontal="end" slot="fixed">
     <ion-fab-button (click)="onClickAddWorkforceForm()" color="primary">
          <ion-icon name="add"></ion-icon>
     </ion-fab-button>
</ion-fab>
